import * as React from 'react'

import { CredentialsFields } from 'main/gql/credentials'
import { UnreachableCaseError } from 'main/util/ts'
import { ScheduleTourModal_school } from '../ScheduleTourModal/common/gql'
import { ITrackData, track } from '../track'
import { AnonymousStep } from '../types'
import Login from './Login'
import SignUp from './SignUp'

interface IProps {
  trackData: ITrackData
  school: ScheduleTourModal_school
  step: AnonymousStep
  onAuth: (credentials: CredentialsFields) => void
  onChangeStep: (step: AnonymousStep) => void
}

export default function Content(props: IProps) {
  const { trackData, school, step, onAuth, onChangeStep } = props

  switch (step.__stepname) {
    case 'sign_up':
      return (
        <SignUp
          school={school}
          onRequestLogin={() => onChangeStep({ __stepname: 'login' })}
          onComplete={(credentials: CredentialsFields) => {
            track('completed_sign_up', trackData)
            onAuth(credentials)
          }}
        />
      )
    case 'login':
      return (
        <Login
          onRequestSignUp={() => onChangeStep({ __stepname: 'sign_up' })}
          onComplete={(credentials: CredentialsFields) => {
            track('completed_login', trackData)
            onAuth(credentials)
          }}
        />
      )
    default:
      throw new UnreachableCaseError(step)
  }
}
